<template>
  <div>
    <vs-card class="p-1">
      <div>
        <div class="vx-row">
          <div class="vx-col w-2/3">
            <label class="vs-input--label">ค้นหาข้อมูลผู้กู้ <small class="text-grey">(โดยสามารถค้นหาได้จาก
              เลขที่บัตรประจำตัวประชาชน รหัสนักศึกษา หรือชื่อ-นามสกุล)</small> <small class="ml-2"
                                                                                      v-if="totalMatched > maxOptions">
              #แสดงผลเพียง {{ maxOptions }} รายการจาก {{ totalMatched }} รายการที่พบ
            </small></label>

            <v-select
              v-model="form.borrower"
              :filterable="false"
              :options="filteredBorrowers"
              :clearable="true"
              @search="onSearchBorrower"
              label="label"
            >
            </v-select>
          </div>
          <div class="vx-col w-1/3 mt-5" style="display: flex; justify-content: flex-end;">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-list"
                       @click="routerList()">รายการผู้กู้
            </vs-button>
            <vs-button color="success" type="filled" icon-pack="feather" icon="icon-user-plus" @click="routerAdd()">
              สร้างผู้กู้
            </vs-button>
          </div>
        </div>
      </div>
      <vs-divider class="mb-3 mt-3"></vs-divider>
      <div v-if="_borrower">
        <div class="vx-row pb-1">
          <div class="vx-col w-2/3">
            <p class="text-2xl align-middle">{{ _borrower.fullName }}</p>
            <div class="text-grey text-sm icon-text-container d-flex align-items-center ">
              <span class="mr-2"><vs-icon icon="mail"></vs-icon></span>
              <span class="mr-2 vertical-align3">{{ _borrower.email }}</span>
              <span class="mr-2"><vs-icon icon="phone_iphone"></vs-icon></span>
              <span class="mr-2 vertical-align3">{{ _borrower.mobile }}</span>
              <span class="mr-2"><vs-icon icon="phone"></vs-icon></span>
              <span class="mr-2 vertical-align3">{{ _borrower.phone }}</span>
            </div>
            <div class="vx-row mt-1 pl-4">
              <div @click="$refs.paymentDetailPopup.handlePopup(_paymentDetailSummary, 'paymentDetail')"
                   class="vx-col bordered-group-dotted mr-1 text-center p-1 pr-5 pl-5  cursor-pointer">
                <a class="text-base text-bold">{{ _paymentDetailSummary.totalPaymentAmount | numberFormat }} ฿</a>
                <p class="text-grey text-sm">รวมยอดชำระทั้งหมด</p>
              </div>
              <div
                @click="$refs.outstandingBalanceRemainDetailPopup.handlePopup(_outstandingBalanceDetailSummary, 'outstandingBalanceRemainDetail')"
                class="vx-col mr-1 text-center p-1 pr-5 pl-5  cursor-pointer"
                :class="_outstandingBalanceDetailSummary.totalOutstandingBalanceRemain > 0 ? 'bordered-group-dotted-danger' : 'bordered-group-dotted-success' ">
                <a
                  :class="_outstandingBalanceDetailSummary.totalOutstandingBalanceRemain > 0 ? 'text-danger' : 'text-success' "
                  class="text-base text-bold">{{
                    _outstandingBalanceDetailSummary.totalOutstandingBalanceRemain | numberFormat
                  }} ฿</a>
                <p class="text-grey text-sm">รวมยอดค้างชำระ</p>
              </div>
              <div class="vx-col mr-1 text-center p-1 pr-5 pl-5 bordered-group-dotted">
                <a class="text-base text-bold text-info">{{ _educationStatusName }}</a>
                <p class="text-grey text-sm">สถานะการศึกษา (มหาวิทยาลัย)</p>
              </div>
            </div>
          </div>
          <div class="vx-col w-1/3">
            <div class="vx-row">
              <div class="vx-col w-full" style="display: flex; justify-content: flex-end;">
                <vs-button class="mr-2" color="warning" type="filled" icon-pack="feather" icon="icon-edit"
                           @click="routerEdit()">แก้ไขข้อมูล
                </vs-button>
                <vs-button color="success" type="filled" icon-pack="feather" icon="icon-file-plus"
                           @click="routerAddContract()">สร้างสัญญา
                </vs-button>
              </div>
            </div>
            <div class="vx-row mt-5 mr-1 text-right">
              <div class="vx-col w-full">
                <div class="vx-row mt-5 d-flex">
                  <div class="w-1/3 text-left text-grey">วงเงินคงเหลือ</div>
                  <div class="w-2/3 text-right">{{ _contractSummary.loanAmount | numberFormat }} /
                    {{ _contractSummary.contractAmount | numberFormat }} บาท
                  </div>
                </div>
                <div class="vx-row mt-1">
                  <vs-progress :percent="_loanAmountPercentage" color="success">success</vs-progress>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bordered-group vs-card vs-con-block mt-5">
          <div class="vs-card-content">
            <div class="vx-row ">
              <div class="vx-col w-full">
                <vs-table max-items="10" :data="_contracts">
                  <template slot="header">
                    <h6 class="mb-5">ประวัติสัญญา</h6>
                  </template>

                  <template slot="thead">
                    <vs-th sort-key="">#</vs-th>
                    <vs-th sort-key="">เลขที่สัญญา</vs-th>
                    <vs-th sort-key="">ชื่อสัญญา</vs-th>
                    <vs-th sort-key="">วันที่สัญญา</vs-th>
                    <vs-th sort-key="">วันที่ปิด บช.</vs-th>
                    <vs-th sort-key="">เงินกู้ตามสัญญา</vs-th>
                    <vs-th sort-key="">เงินกู้ตามจริง</vs-th>
                    <vs-th sort-key="">เงินต้นคงเหลือ</vs-th>
                    <vs-th sort-key="">สถานะ</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                      <vs-td :data="index + 1">
                        {{ index + 1 }}
                      </vs-td>
                      <vs-td :data="row.contractNo">
                        <a @click="routerMangeTransaction(row.id)" class="cursor-pointer">{{
                            row.contractNo
                          }} </a><b><u>{{ row.contractSeq }}</u></b>
                      </vs-td>
                      <vs-td :data="row.contractName">
                        <a @click="routerMangeTransaction(row.id)" class="cursor-pointer">{{ row.contractName }} </a>
                      </vs-td>
                      <vs-td :data="row.contractDate">
                        {{ row.contractDate | convYYYYMMDDToDDMMYYYY }}
                      </vs-td>
                      <vs-td :data="row.contractCloseDate">
                        {{ row.contractCloseDate | convYYYYMMDDToDDMMYYYY }}
                      </vs-td>
                      <vs-td :data="row.contractAmount">
                        {{ row.contractAmount | numberFormat }}
                      </vs-td>
                      <vs-td :data="row.loanAmount">
                        {{ row.loanAmount | numberFormat }}
                      </vs-td>
                      <vs-td :data="row.principleRemain">
                        {{ row.principleRemain  | numberFormat }}
                      </vs-td>
                      <vs-td :data="row.contractSummarizeStatus">
                        <vs-chip :color="row.contractSummarizeStatus | contractSummarizeStatusColor">
                          {{ row  | contractSummarizeStatus }}
                        </vs-chip>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>

            <div class="vx-row flex mt-5">
              <div class="vx-col flex-1">
                <label class="vs-input--label">จำนวนสัญญา<span
                  class="ml-1 text-grey text-sm">(เฉพาะสัญญาที่ Active)</span></label>
                <vs-input type="text" v-bind:value="_contractSummary.count" class="w-full" disabled="disabled"/>
              </div>
              <div class="vx-col flex-1">
                <label class="vs-input--label">รวมเงินกู้ตามสัญญา (บาท)</label>
                <vs-input type="text" v-bind:value="_contractSummary.contractAmount | numberFormat" class="w-full"
                          disabled="disabled"/>
              </div>
              <div class="vx-col flex-1">
                <label class="vs-input--label">รวมเงินกู้ตามจริง (บาท)</label>
                <vs-input type="text" v-bind:value="_contractSummary.loanAmount  | numberFormat" class="w-full"
                          disabled="disabled"/>
              </div>
              <div class="vx-col flex-1">
                <label class="vs-input--label">รวมเงินต้นที่ชำระแล้ว (บาท)</label>
                <vs-input type="text" v-bind:value="_contractSummary.paidPrinciple  | numberFormat" class="w-full"
                          disabled="disabled"/>
              </div>
              <div class="vx-col flex-1">
                <label class="vs-input--label">รวมเงินต้นคงเหลือ (บาท)</label>
                <vs-input type="text" v-bind:value="_contractSummary.principleRemain  | numberFormat" class="w-full"
                          disabled="disabled"/>
              </div>
            </div>
          </div>
        </div>

        <div class="bordered-group vs-card vs-con-block mt-5">
          <div class="vs-card-content">
            <div class="vx-row ">
              <div class="vx-col w-full">
                <vs-table max-items="10" :data="_suretyContracts">
                  <template slot="header">
                    <h6 class="mb-5">การคำ้ประกัน</h6>
                  </template>

                  <template slot="thead">
                    <vs-th sort-key="">#</vs-th>
                    <vs-th sort-key="">เลขที่สัญญา</vs-th>
                    <vs-th sort-key="">ชื่อสัญญา</vs-th>
                    <vs-th sort-key="">วันที่สัญญา</vs-th>
                    <vs-th sort-key="">วันที่ปิด บช.</vs-th>
                    <vs-th sort-key="">เงินกู้ตามสัญญา</vs-th>
                    <vs-th sort-key="">เงินกู้ตามจริง</vs-th>
                    <vs-th sort-key="">เงินต้นคงเหลือ</vs-th>
                    <vs-th sort-key="">สถานะ</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                      <vs-td :data="index + 1">
                        {{ index + 1 }}
                      </vs-td>
                      <vs-td :data="row.contractNo">
                        <a @click="routerMangeTransaction(row.id)" class="cursor-pointer">{{
                            row.contractNo
                          }} </a><b><u>{{ row.contractSeq }}</u></b>
                      </vs-td>
                      <vs-td :data="row.contractName">
                        <a @click="routerMangeTransaction(row.id)" class="cursor-pointer">{{ row.contractName }} </a>
                      </vs-td>
                      <vs-td :data="row.contractDate">
                        {{ row.contractDate | convYYYYMMDDToDDMMYYYY }}
                      </vs-td>
                      <vs-td :data="row.contractCloseDate">
                        {{ row.contractCloseDate | convYYYYMMDDToDDMMYYYY }}
                      </vs-td>
                      <vs-td :data="row.contractAmount">
                        {{ row.contractAmount | numberFormat }}
                      </vs-td>
                      <vs-td :data="row.loanAmount">
                        {{ row.loanAmount | numberFormat }}
                      </vs-td>
                      <vs-td :data="row.principleRemain">
                        {{ row.principleRemain  | numberFormat }}
                      </vs-td>
                      <vs-td :data="row.contractStatus">
                        <vs-chip :color="row.contractSummarizeStatus | contractSummarizeStatusColor">
                          {{ row  | contractSummarizeStatus }}
                        </vs-chip>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>

            <div class="vx-row flex mt-5">
              <div class="vx-col flex-1">
                <label class="vs-input--label">จำนวนสัญญา<span
                  class="ml-1 text-grey text-sm">(เฉพาะสัญญาที่ Active)</span></label>
                <vs-input type="text" v-bind:value="_contractSuretySummary.count" class="w-full" disabled="disabled"/>
              </div>
              <div class="vx-col flex-1">
                <!--                <label class="vs-input&#45;&#45;label">รวมเงินกู้ตามสัญญา (บาท)</label>-->
                <!--                <vs-input type="text" v-bind:value="amount" class="w-full" disabled="disabled"/>-->
              </div>
              <div class="vx-col flex-1">
                <!--                <label class="vs-input&#45;&#45;label">รวมเงินกู้ตามจริง (บาท)</label>-->
                <!--                <vs-input type="text" v-bind:value="amount" class="w-full" disabled="disabled"/>-->
              </div>
              <div class="vx-col flex-1">
                <!--                <label class="vs-input&#45;&#45;label">รวมเงินต้นที่ชำระแล้ว (บาท)</label>-->
                <!--                <vs-input type="text" v-bind:value="amount" class="w-full" disabled="disabled"/>-->
              </div>
              <div class="vx-col flex-1">
                <label class="vs-input--label">รวมเงินต้นคงเหลือ (บาท)</label>
                <vs-input type="text" v-bind:value="_contractSuretySummary.principleRemain  | numberFormat"
                          class="w-full" disabled="disabled"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!_borrower">
        <p>กรุณาค้นหาข้อมูล</p>
      </div>
    </vs-card>
    <custom-popup ref="paymentDetailPopup" title="รายละเอียดยอดชำระทั้งหมด"/>
    <custom-popup ref="outstandingBalanceRemainDetailPopup" title="รายละเอียดยอดค้างชำระทั้งหมด"/>
  </div>
</template>

<script>
import vSelect from 'vue-select'

import {ValidationProvider} from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import {createNamespacedHelpers, mapGetters} from "vuex";
import {round} from "@/utils";
import {IContractStatus} from "@/constants/interface";
import CustomPopup from "@/views/components/custom/Popup.vue";

const {mapActions: mapCustomerActions, mapState: mapCustomerFields} = createNamespacedHelpers('Customer');

export default {
  components: {
    CustomPopup,
    vSelect,
    ValidationProvider,
    flatPickr
  },
  data() {
    return {
      form: {
        borrower: null,
      },
      filteredBorrowers: [],
      totalMatched: 0,
      searchTimeout: null,
      maxOptions: 15,
      debounceTime: 500,
    }
  },
  async created() {
    const vm = this
    const {initializing} = vm
    initializing(true);
    await vm.loadOptions();
    await vm.initData();
    initializing(false);
  },
  computed: {
    ...mapCustomerFields(['status', 'borrowerSearch']),
    ...mapGetters({
      borrowerSearchOptions: "Customer/borrowerSearchOptions",
    }),
    _borrower() {
      if (this.borrowerSearch) {
        let borrower = this.borrowerSearch
        borrower = {
          ...borrower,
          phone: borrower.phone ? borrower.phone : '-',
          mobile: borrower.mobile ? borrower.mobile : '-',
          email: borrower.email ? borrower.email : '-',
        }
        return borrower ? borrower : null
      } else {
        return null
      }
    },
    _contracts() {
      if (this.borrowerSearch) {
        const {contracts} = this.borrowerSearch
        return contracts
      } else {
        return []
      }
    },
    _suretyContracts() {
      if (this.borrowerSearch) {
        const {suretyContracts} = this.borrowerSearch
        return suretyContracts
      } else {
        return []
      }
    },
    _contractSummary() {
      if (this.borrowerSearch) {
        const {contracts} = this.borrowerSearch
        const filteredContracts = contracts.filter(res => {
          return res.contractStatus === IContractStatus.approved
        })
        const count = filteredContracts.length
        const contractAmount = filteredContracts.reduce((acc, val) => acc + val.contractAmount, 0)
        const loanAmount = filteredContracts.reduce((acc, val) => acc + val.loanAmount, 0)
        const principleRemain = filteredContracts.reduce((acc, val) => acc + val.principleRemain, 0)
        const paidPrinciple = round(loanAmount - principleRemain, 2)
        return {
          count,
          contractAmount,
          loanAmount,
          paidPrinciple,
          principleRemain,
        }
      } else {
        return {
          count: 0,
          contractAmount: 0,
          loanAmount: 0,
          paidPrinciple: 0,
          principleRemain: 0,
        }
      }
    },
    _contractSuretySummary() {
      if (this.borrowerSearch) {
        const {suretyContracts} = this.borrowerSearch
        const filteredSuretyContracts = suretyContracts.filter(res => {
          return res.contractStatus === IContractStatus.approved
        })
        const count = filteredSuretyContracts.length
        const principleRemain = filteredSuretyContracts.reduce((acc, val) => acc + val.principleRemain, 0)
        return {
          count,
          principleRemain,
        }
      } else {
        return {
          count: 0,
          principleRemain: 0,
          // paymentAmount: 0,
          // outstandingBalanceRemain: 0,
        }
      }
    },
    _paymentDetailSummary() {
      if (this.borrowerSearch) {
        const {contracts} = this.borrowerSearch
        const result = contracts.reduce((acc, {paymentDetail}) => {
          acc.paidFee += paymentDetail.paidFee;
          acc.paidPenalty += paymentDetail.paidPenalty;
          acc.paidInterest += paymentDetail.paidInterest;
          acc.paidPrinciple += paymentDetail.paidPrinciple;
          acc.balanceRemain += paymentDetail.balanceRemain;
          return acc;
        }, {
          paidFee: 0,
          paidPenalty: 0,
          paidInterest: 0,
          paidPrinciple: 0,
          balanceRemain: 0
        });

        result.totalPaymentAmount = result.paidFee + result.paidPenalty + result.paidInterest + result.paidPrinciple;
        return result;
      } else {
        return {
          paidFee: 0,
          paidPenalty: 0,
          paidInterest: 0,
          paidPrinciple: 0,
          balanceRemain: 0,
          totalPaymentAmount: 0
        }
      }
    },
    _outstandingBalanceDetailSummary() {
      if (this.borrowerSearch) {
        const {contracts} = this.borrowerSearch
        const filteredContracts = contracts.filter(res => {
          return res.contractStatus === IContractStatus.approved
        })
        const result = filteredContracts.reduce((acc, {outstandingBalanceDetail}) => {
          acc.accruedFeeRemain += outstandingBalanceDetail.accruedFeeRemain;
          acc.accruedPenaltyRemain += outstandingBalanceDetail.accruedPenaltyRemain;
          acc.outstandingAmountRemain += outstandingBalanceDetail.outstandingAmountRemain;
          return acc;
        }, {
          accruedFeeRemain: 0,
          accruedPenaltyRemain: 0,
          outstandingAmountRemain: 0
        });

        result.totalOutstandingBalanceRemain = result.accruedFeeRemain + result.accruedPenaltyRemain + result.outstandingAmountRemain;
        return result;
      } else {
        return {
          accruedFeeRemain: 0,
          accruedPenaltyRemain: 0,
          outstandingAmountRemain: 0,
          totalOutstandingBalanceRemain: 0
        }
      }
    },
    _loanAmountPercentage() {
      return round(this._contractSummary.loanAmount / this._contractSummary.contractAmount * 100, 2)
    },
    _educationStatusName() {
      if (this.borrowerSearch) {
        const {borrowerEducationInformation} = this.borrowerSearch
        return borrowerEducationInformation ? borrowerEducationInformation.educationStatusName : null
      } else {
        return null
      }
    }
  },
  methods: {
    ...mapCustomerActions(['initializing', 'getBorrowerOptions', 'getBorrowerForBorrowerSearch']),
    onSearchBorrower(searchText) {
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        const search = searchText.trim().toLowerCase();

        const matched = this.borrowerSearchOptions.filter(b =>
          b.label.toLowerCase().includes(search)
        );

        this.totalMatched = matched.length;
        this.filteredBorrowers = matched.slice(0, this.maxOptions);
      }, this.debounceTime);
    },
    async loadOptions() {
      const vm = this
      const {borrowerSearchOptions} = vm
      const {getBorrowerOptions} = vm
      if (borrowerSearchOptions.length === 0) await getBorrowerOptions();

      if (this.borrowerSearch) {
        const selectedBorrower = vm.borrowerSearchOptions.find(b => b.value ===  this.borrowerSearch.id);
        await this.onSearchBorrower(selectedBorrower.label);
      } else {
        await this.onSearchBorrower('');
      }
    },
    async initData() {
      const vm = this
      if (this.$route.params.id) {
        const selectedBorrower = vm.borrowerSearchOptions.find(b => b.value ===  this.$route.params.id);
        vm.form = {
          borrower: selectedBorrower
        }
      } else if (this.borrowerSearch) {
        const selectedBorrower = vm.borrowerSearchOptions.find(b => b.value ===  this.borrowerSearch.id);
        vm.form = {
          borrower: selectedBorrower
        }
      }
    },
    routerList: function () {
      this.$router.push({name: 'customer-borrower-list'});
    },
    routerAdd: function () {
      this.$router.push({name: 'customer-borrower-add'});
    },
    routerEdit: function () {
      this.$router.push({name: 'customer-borrower-edit', params: {id: this._borrower.id}})
    },
    routerAddContract: function () {
      this.$router.push({name: 'accounting-contract-add', params: {id: this._borrower.id}})
    },
    routerMangeTransaction: function (id) {
      this.$router.push({name: 'accounting-contract-detail', params: {id: id}});
    },
  },
  watch: {
    "form.borrower": async function (borrower) {
      const borrowerId = borrower ? borrower.id : null
      const vm = this
      const {getBorrowerForBorrowerSearch} = vm // setProcessing,
      await getBorrowerForBorrowerSearch({
        form: {
          id: borrowerId
        }
      });
    },
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
}
</script>

<style scoped>
.bordered-group-dotted {
  border: 1px dotted #ddd; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.bordered-group-dotted-danger {
  border: 1px dotted #ddd; /* Custom border */
  //border: 1px dotted  #FF4D4F; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.bordered-group-dotted-success {
  border: 1px dotted #ddd; /* Custom border */
  //border: 1px dotted #28C76F; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.bordered-group {
  border: 1px solid #ddd; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.vertical-align3 {
  vertical-align: 3px;
}
</style>
